module.exports = __webpack_public_path__ + "img/paciano.a6ef4696.png";